export interface ScopeOfPractice {
  id: string;
  name: string;
  abbreviation: string;
}
